export default "__VITE_ASSET__CoQx9MMB__"